import React from 'react'

import { useParams } from 'react-router'

import { FrozenMealDishDetailsFragment, useOneFrozenMealDishQuery } from '@hooks/api'
import { CraftMealPDP, DetailPageWrapper } from '@organisms/index'
import { ProductStatusEnum } from '@uctypes/api/globalTypes'
import { SearchEngineOptimization, SearchEngineOptimizationParams } from '@utility/SearchEngineOptimization'

const seo = (dish?: FrozenMealDishDetailsFragment): SearchEngineOptimizationParams => ({
  name: 'UCOOK Craft Meal Dish',
  title: `${dish?.name ?? 'Awesome'} Recipe & Ingredients | UCOOK`,
  meta: [{
    name: 'description',
    content: `${dish?.description ?? 'Amazing Recipe'}`,
  }, {
    name: 'keywords',
    content: `${dish?.name ?? 'Awesome'} Recipe,${dish?.name ?? 'Awesome'} Ingredients,${dish?.name ?? 'Awesome'} delivery`,
  }, {
    name: 'robots',
    content: 'index,follow',
  }],
})

export function CraftMealDetails(): JSX.Element {

  const { slug } = useParams<{ slug: string }>()
  const { data, loading, error } = useOneFrozenMealDishQuery({
    variables: {
      slug,
      status: [ProductStatusEnum.PUBLISHED],
    },
  })

  const dish = data?.dish

  return (
    <DetailPageWrapper
      loading={loading && !dish}
      error={error}
      pdp={<CraftMealPDP dish={dish} loading={loading} />}
      seo={<SearchEngineOptimization seo={seo(dish)} />} />
  )
}
